import { t } from '@ankr.com/common';

export const getDisabledChainTooltipText = (shouldShowText: boolean) => {
  if (!shouldShowText) return '';

  return t('error.project-chains-config');
};
